import React, { useState, useEffect } from 'react';
import { useSearchParams, Navigate, useParams } from 'react-router-dom';
import ReviewForm from '../../components/ReviewForm';
import {
   API_ENDPOINTS,
   Card,
   CardBody,
   customToast,
   PageLayoutPublic,
   route,
   Spinner,
   SubTitle,
   Variants,
   WidthConstrainedContainer,
} from 'carrier-fe';
import Success from './Success';
import axios from 'axios';
import { HouseholderInstallationView } from '../../types/Registration/Journey';

function ReviewPage() {
   const params = useParams();
   const [searchParams] = useSearchParams();
   const installationId = params.installationId || '';
   const [hasSubmitted, setHasSubmitted] = useState(false);
   const [isLoading, setIsLoading] = useState(true);

   const fetchInstallation = async () => {
      setIsLoading(true);
      try {
         const response = await axios.get<{data:HouseholderInstallationView}>(
            route(API_ENDPOINTS.HOUSEHOLDER.REGISTRATION.VIEW, { installationId })
         );
         const installation = response.data;
         setHasSubmitted(installation?.data?.review_submitted);
      } catch (error: any) {
         customToast({
            variant: Variants.Danger,
            title: error?.response?.data?.message || 'Error fetching installation',
         });
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      fetchInstallation();
   }, [installationId]);

   return (
      <PageLayoutPublic title="Review">
         <WidthConstrainedContainer maxWidth={1440}>
            {isLoading ? (
               <div className="d-flex justify-content-center align-items-center vh-100">
                  <Spinner />
               </div>
            ) : (
               <Card>
                  <CardBody>
                     {hasSubmitted ? (
                        <Success />
                     ) : (
                        <>
                           <SubTitle className="text-center mb-4" title="Leave your review!" />
                           <ReviewForm />
                        </>
                     )}
                  </CardBody>
               </Card>
            )}
         </WidthConstrainedContainer>
      </PageLayoutPublic>
   );
}

export default ReviewPage;
